module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/howto3-a88ab3aefd99441bf81f46b600d91c87.png";